/**
 * Build-time app config (Vite import.meta.env), baked into the bundle.
 *
 * Replaces the old runtime fetch('/env.json') + window.__ENV__ pattern: the
 * values were always fixed at build time, so fetching them at runtime only
 * added a render-blocking round-trip and a white-screen failure mode.
 *
 * Sources: apps/admin/.env.local, written by `node scripts/generate-env.js
 * <stage> admin` (local dev reads env/admin.<stage>.json; CI/Cloudflare Pages
 * reads the ENV_JSON_ADMIN variable). All values here are public-by-design —
 * they ship in browser JS either way.
 *
 * window.__ENV__ is still assigned (synchronously) from this object in
 * main.tsx as a transitional shim for existing read sites. New code should
 * import { config } from this module instead.
 */

export type AdminConfig = {
  STAGE: string;
  SUPABASE_URL: string;
  SUPABASE_ANON_KEY: string;
  EDGE_BASE?: string;
  SSE_URL?: string;
  POSTHOG_PUBLIC_KEY?: string;
  POSTHOG_PUBLIC_HOST?: string;
  SITE_URL?: string;
  SEEKER_URL?: string;
};

const env = import.meta.env;

export const config: AdminConfig = {
  STAGE: env.VITE_STAGE ?? '',
  SUPABASE_URL: env.VITE_SUPABASE_URL ?? '',
  SUPABASE_ANON_KEY: env.VITE_SUPABASE_ANON_KEY ?? '',
  EDGE_BASE: env.VITE_EDGE_BASE,
  SSE_URL: env.VITE_SSE_URL,
  POSTHOG_PUBLIC_KEY: env.VITE_POSTHOG_PUBLIC_KEY,
  POSTHOG_PUBLIC_HOST: env.VITE_POSTHOG_PUBLIC_HOST,
  SITE_URL: env.VITE_SITE_URL,
  SEEKER_URL: env.VITE_SEEKER_URL,
};

const required: (keyof AdminConfig)[] = ['STAGE', 'SUPABASE_URL', 'SUPABASE_ANON_KEY'];
const missing = required.filter((k) => !config[k]);
if (missing.length > 0) {
  // A build-time mistake (generate-env.js also guards this); fail loudly.
  throw new Error(
    `Missing required build-time config: ${missing.join(', ')}. ` +
      'Run `node scripts/generate-env.js <stage> admin` before building.'
  );
}

declare global {
  interface Window {
    /** Transitional shim — assigned from `config` in main.tsx. Prefer importing { config }. */
    __ENV__: AdminConfig;
  }
}
